import * as Sentry from '@sentry/browser';

import vars from '../../../../vars.js';

function init() {
  Sentry.init({
    dsn: 'https://5ad6b69f85d7414e93cdee78a8f42590@o52731.ingest.sentry.io/5457199',
    release: `Client Website: ${vars.slug}`,
  });
}

export default {
  init,
}; 


// WEBPACK FOOTER //
// ./src/static/js/modules/sentry.js